<template>
  <v-card tabindex="-1" @keydown.esc="$emit('close')" @keydown.enter="$emit('enter')">
    <v-layout column>
      <v-toolbar card dense light flat>
      <v-toolbar-title>
        <v-flex>
          <v-layout row>
            <v-toolbar-title v-if="getIsMobile">Выберите</v-toolbar-title>
            <v-toolbar-title v-if="!getIsMobile">{{title}}</v-toolbar-title>
          </v-layout>
        </v-flex>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-actions-btn :caption="sourceActionsCaption()" :actions="sourceActions()"></v-actions-btn>
      <v-btn icon @click="cancel">
        <v-icon>close</v-icon>
      </v-btn>
      </v-toolbar>
    <div v-if="sourceIs('LOCAL')">      
      <v-people-selector-tab :query="request" :radio="radio" :fullscreen="fullscreen" :selected="cxt.selected()" v-on:input="changeSelected" v-on:change="changeRequest" :methodsQueue="methodsQueue"></v-people-selector-tab>
    </div>
    <div v-if="sourceIs('SEARCH')">
      <v-human-selector-tab :query="request" :queryCxt="queryCxt" :radio="radio" :fullscreen="fullscreen" :selected="cxt.selected()" v-on:input="changeSelected" :methodsQueue="methodsQueue"></v-human-selector-tab>
    </div>
    <v-card-actions>
      <v-btn :disabled='cxt.selectedCount() === 0' @click="ok">ОК</v-btn>
      <v-spacer></v-spacer>
      <v-btn v-show="cxt.selectedCount() === 0 && !radio" @click="checkAll()">Выбрать все</v-btn>
      <v-btn v-show="cxt.selectedCount() > 0" @click="cxt.clear()">Очистить</v-btn>
      <span tabindex="0" v-on:focus="firstFocus()"></span>            
    </v-card-actions>
    </v-layout>    
  </v-card>
</template>

<script type="text/javascript">
  import { mapGetters } from 'vuex'
  import formats from '../../api/formats'
  import classes from '../../api/classes'
  import dialogs from '../common/dialogs.js'
  import people from '../people/index.js'
  import client from '../client/index.js'
  import vActionsBtn from '../common/ActionsBtn'
  import vPeopleSelectorTab from './PeopleSelectorTab.vue'
  import vHumanSelectorTab from './HumanSelectorTab.vue'

  class SourceAction extends classes.Action {
    constructor (context, key, title, visibleFunc, runFunc) {
      super(context, title, visibleFunc, runFunc)
      this.key = key
    }
    run () {
      return this.runFunc(this)
    }
  }

  export default {
    name: 'individual-selector',
    components: {vActionsBtn, vPeopleSelectorTab, vHumanSelectorTab},
    data: () => ({
      request: '',
      source: null,
      sources: [],
      cxt: null,
      radioItem: null,
      methodsQueue: []
    }),
    created () {
      let cxt = new classes.MultiSelectContext(() => {})
      cxt.mode = classes.modes.SELECT
      cxt.filterMode = true
      this.cxt = cxt
      this.sources = this.sourceActions()
      this.source = this.sources && this.sources.length > 0 ? this.sources[0] : null
      this.request = this.query
    },
    mounted () {
      this.sources = this.sourceActions()
      this.source = this.sources && this.sources.length > 0 ? this.sources[0] : null
      this.request = this.query
      this.setFocus()
    },
    watch: {
    },
    props: {
      fullscreen: {
        type: Boolean,
        default: false
      },
      radio: {
        type: Boolean,
        default: false
      },
      queryCxt: {
        type: String,
        default: null
      },
      query: {
        type: String,
        default: null
      }
    },
    computed: {
      ...mapGetters({
        getIsMobile: 'getIsMobile',
        getProfileHaveClient: 'getProfileHaveClient'
      }),
      title () {
        return 'Выберите персону'
      },
      items () {
        return []
      }
    },
    methods: {
      setFocus () {
        this.$nextTick(function () {
          console.log('firstFocus', document.activeElement, this.$el.contains(document.activeElement))
          if (!this.$el.contains(document.activeElement)) {
            this.$el.focus()
          }
        })
      },
      firstFocus () {
        let input = this.$el.querySelector('input')
        console.log('firstFocus', input)
        if (input) {
          input.focus()
        } else {
          this.$el.focus()
        }
      },
      ok () {
        let result = []
        let convert = []
        this.cxt.selected().forEach(e => {
          if (e.split('inn:').length > 1) {
            convert.push(e.split('inn:')[1])
          } else {
            result.push(e)
          }
        })
        this.convertResult(convert)
          .then(data => {
            result = result.concat(data)
            this.$emit('input', result)
            this.cancel()
          })
      },
      cancel () {
        this.$emit('close')
        this.item = null
      },
      convertResult (inns) {
        return new Promise((resolve, reject) => {
          if (inns.length > 0) {
            people.findPeopleByInn(inns[0]).then(data => {
              if (data && data.content) {
                if (data.content.length > 0) {
                  resolve([data.content[0].id])
                } else {
                  dialogs.confirm(this,
                    'Подтвердите',
                    `Создать запись о персоне в локальной базе компании?`,
                      (self) => {
                        client.getHumanProps(inns[0]).then((human) => {
                          people.addHuman(this.queryCxt, human).then((id) => {
                            resolve(id)
                          })
                        })
                      })
                }
              }
            })
          } else {
            resolve([])
          }
        })
      },
      checkAll () {
        this.methodsQueue.push({name: 'checkAll', params: {}})
      },
      changeSelected (ids) {
        console.log('changeSelected', ids)
        this.cxt.setSelected(ids)
      },
      changeRequest (e) {
        this.request = e
      },
      sourceActionsCaption () {
        return this.source ? this.source.caption() : null
      },
      sourceIs (key) {
        return this.source && formats.compareString(this.source.key, key) === 0
      },
      getSourceAction (key) {
        return this.sources.find(o => formats.compareString(o.key, key) === 0)
      },
      sourceActions () {
        let result = []
        if (this.queryCxt) {
          result.push(new SourceAction(this, 'SEARCH', 'Администрация', null, (self) => { this.source = self }))
        }
        result.push(new SourceAction(this, 'LOCAL', 'Физические лица', null, (self) => { this.source = self }))
        return result
      }
    }

  }

</script>




// WEBPACK FOOTER //
// IndividualSelector.vue?1fe6ef43